import { render } from "./QuickSearchConcerns.vue?vue&type=template&id=50e00bf9"
import script from "./QuickSearchConcerns.vue?vue&type=script&lang=js"
export * from "./QuickSearchConcerns.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__